import {Injectable} from '@angular/core';

@Injectable()
export class UniqueIdGenerator {

    public generate(): string {
        return "_temp_"+Math.random().toString(36).substr(2,12);
    }
}


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/angular-router-loader/src!./src/dashboard/app/shared/revenue/exceptions/unique-id-generator.service.ts